/* eslint-disable max-len */
import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
// import { TopBanner } from "../../common/TopBanner";
import masterData from "../../lib/masterData";

export const app = (type, mode) => {
  document.title =
    "トランクルームをお探しなら『ハローストレージ』【公式】｜交通系ICカード利用について ";

  const contactType = masterData.contactType.bySlug.felica_key;
  console.log(contactType.phoneNumber);
  console.log(contactType.name);

  return (
    <div className="container">
      {breadcrumbs(type, [{ text: "交通系ICカード利用について" }])}
      <div className="flow whatsfelica">
          <div className="content">
              <h3 className="whatstitle">交通系ICカード利用について</h3>
              <div className="whatsarea">
                  <p className="touch-ill"><img src="resource/img/static/app/touch-card-ill.png" alt="" /></p>
              </div>
              <p className="whatstext">
                駅の改札口で交通系ICカードをタッチしたり、コンビニエンスストアで電子マネーを利用したり、普段皆さんがお使いのICカードが、ご契約物件のメインキーとして使用可能になる入退館管理システム(セントラル警備保障株式会社  商品)が対象のトランクルームに設置されております。ご利用いただくためにはマイページよりID番号の登録が必要です。<br />
                また、本システムで利用できる交通系ICカードは10種※1となります。<br />
                ※1  Suica・PASMO・ICOCA・nimoca・PiTaPa・TOICA・はやかけん・manaca・Kitaca・SUGOCA
              </p>
              <div className="cationarea">
                  <p className="cationtitle">ご利用上の注意</p>
                  <p className="cationtext">
                    交通系ICカードの紛失や破損等により使用ができなくなった際には、弊社にてご購入いただくか、所定の交通機関窓口にて購入もしくは交換等をしていただきますようお願いいたします。その際、ID番号が変更になった場合、改めてマイページより再登録を行っていただく必要がございます。
                    <br />交通系ICカード登録方法に関しては、マイページログイン後「マイページメニュー」より「交通系ICカードの登録」をご確認ください。
                  </p>
              </div>
              <h3 className="felicaflow"><span><img src="resource/img/static/app/iccard.svg" alt="" /></span>交通系ＩＣカード登録手順</h3>
              <p className="whatstext">お手持ちの交通系ICカードをご契約物件のメインキーとしてご利用の場合は、ご契約後に「マイページ」より登録が必要です。</p>
              <p className="flow-ill"><img src="resource/img/static/app/flow1-pc.svg" alt="手順" width="900" /></p>
              <p className="flow-ill-sp"><img src="resource/img/static/app/flow1-sp.svg" alt="手順" width="90%" /></p>
              <p className="mypage-ill"><img src="resource/img/static/app/flow2-pc.svg" alt="マイページ" width="900" /></p>
              <p className="mypage-ill-sp"><img src="resource/img/static/app/flow2-sp.svg" alt="マイページ" width="90%" /></p>
              <p className="login_btn">
                <a href="/mypage3" target="_blank" rel="noopener noreferrer">
                  <img src="resource/img/static/app/login_btn.svg" alt="マイページへログイン" width="100%" />
                </a>
              </p>
              <h3 className="felicaflow"><span><img src="resource/img/static/app/iccard.svg" alt="" /></span>交通系ＩＣカード番号確認</h3>
              <p className="mypage-ill"><img src="resource/img/static/app/flow3-pc.svg" alt="カードタイプ、モバイルアプリタイプ" width="900" /></p>
              <p className="mypage-ill-sp"><img src="resource/img/static/app/flow3-sp.svg" alt="カードタイプ、モバイルアプリタイプ" width="90%" /></p>
              <h3 className="felicaflow"><span><img src="resource/img/static/app/iccard.svg" alt="" /></span>交通系ＩＣカード新規購入方法</h3>
              <p className="whatstext">弊社より交通系ICカードを購入して、ご契約物件のメインキーとしてご利用されたい場合は、下記方法にてお求めください。</p>
              <h4 className="procedure">■新規お申し込みのお客様</h4>
              <h5 className="procedure-p">「申込み情報入力」画面の「新しい交通系ICカードを購入する」より、ご希望の枚数をご入力の上お申し込みください。</h5>
              <p className="mypage-ill"><img src="resource/img/static/app/flow4-pc.svg" alt="マイページ" width="900" /></p>
              <p className="mypage-ill-sp"><img src="resource/img/static/app/flow4-sp.svg" alt="マイページ" width="90%" /></p>
              <h4 className="procedure">■ご契約済みのお客様</h4>

              {

                  /* 2020/10/15時点の仕様ではマイページから購入する機能がないためコメントアウトし、「お手数ですが、下記までお問合せください。<br />0120-52-4185」を表示
                  <h5 className="procedure-p">「マイページ」へログイン後「交通系ICカード購入」より、ご希望の枚数をご入力の上お申し込みください。</h5>
                  <p className="mypage-ill"><img src="resource/img/static/app/flow5-pc.svg" alt="マイページ" width="900" /></p>
                  <p className="mypage-ill-sp"><img src="resource/img/static/app/flow5-sp.svg" alt="マイページ" width="90%" /></p>
                  */
              }

              <p className="mypage-ill">
                <a href={contactType.phoneUrl}><img src="resource/img/static/app/tel_pc.svg" alt={contactType.phoneNumber} width="900" /></a>
              </p>
              <p className="mypage-ill-sp">
                <a href={contactType.phoneUrl}><img src="resource/img/static/app/tel_sp.svg" alt={contactType.phoneNumber} width="90%" /></a>
              </p>
              <p className="login_btn">
                <a href="/mypage3" target="_blank" rel="noopener noreferrer">
                  <img src="resource/img/static/app/login_btn.svg" alt="マイページへログイン" width="100%" />
                </a>
              </p>
          </div>
      </div>

    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/new/app.jsx